import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Container, Content, Title, Bubble, i18n, tokens } from '@simplybenefits/sb-ui-library';
import * as dates from '@simplybenefits/sb-dates';
import { navigateTo } from '../../services/helpers.js';
import UsageTab from './UsageTab.js';
import { setCurrentSidebarItem, getUsage } from '../../actions/user.js';

class Usage extends PureComponent {
    state = {
        value: 0,
        selectedUsage: this.props.usage.user,
        viewingLastYear: false,
        usage: this.props.usage
    };

    componentDidMount() {
        // redirect members if they attempt to access this page through the url and are in a isSpendingAccountOnly class
        const isSpendingAccountOnly = this.props?.meta?.isSpendingAccountOnly === 1; 
        if (isSpendingAccountOnly) {
            navigateTo('/not-found');
        }

        this.props.dispatch(setCurrentSidebarItem('usage'));
    }

    _handleChange = (value) => {
        this.setState({
            value,
            selectedUsage: Number(value) === 0 ? this.state.usage.user : this.state.usage.dependents[value - 1].usage,
            isDependentUsage: Number(value) !== 0
        });
    };

    _viewCurrentUsage = () => {
        window.location.reload();
    };

    _viewLastYearUsage = async () => {
        const currentYear = new Date().getFullYear();
        const date = dates.getStartOfDay(`${ currentYear - 1 }-12-01`); // set the service date year to some time in the last year

        const usage = await this.props.dispatch(getUsage(date));

        if (usage) {
            this.setState({
                usage,
                viewingLastYear: true,
                selectedUsage: Number(this.state.value) === 0 ? usage.user : usage.dependents[this.state.value - 1].usage
            });
        }
    };

    render() {
        const { meta } = this.props;

        let waivedEHC = false;
        let waivedDental = false;

        if (meta.hasWaived && meta.hasWaived.includes('Health')) {
            waivedEHC = !meta.waiveFor.includes('Self') ?
                (meta.isDependent || this.state.isDependentUsage)
                :
                true;
        }

        if (meta.hasWaived && meta.hasWaived.includes('Dental')) {
            waivedDental = !meta.waiveFor.includes('Self') ?
                (meta.isDependent || this.state.isDependentUsage)
                :
                true;
        }

        const styles = {
            tabsRoot: {
                marginLeft: -57
            },
            titleBlock: {
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                alignItems: 'center'
            }
        };

        return (
            <Container>
                <Content>
                    <div style={ styles.titleBlock }>
                        <Title title={ i18n.t(tokens.titles.usage) } customStyle={{ flex: 1 }}/>

                        {
                            this.props.meta.isSurvivorBenefitParent === 0 &&
                            <>
                                {
                                    this.state.viewingLastYear ?
                                        <Button
                                            color="primary"
                                            customStyle={{
                                                height: 50,
                                                width: 200,
                                                textTransform: "capitalize",
                                                fontSize: 16
                                            }}
                                            onClick={ this._viewCurrentUsage }
                                        >
                                            { i18n.t(tokens.buttons["view current usage"]) }
                                        </Button>
                                        :
                                        <Button
                                            color="white"
                                            noHover
                                            customStyle={{
                                                height: 50,
                                                width: 180,
                                                textTransform: "capitalize",
                                                fontSize: 16
                                            }}
                                            onClick={ this._viewLastYearUsage }
                                        >
                                            { i18n.t(tokens.buttons["view last year"]) }
                                        </Button>
                                }
                            </>
                        }
                    </div>

                    <div style={{
                        marginBottom: 20
                    }}>
                        <Bubble
                            label={ i18n.t(tokens.titles.usage) }
                            isSelected={ this.state.value === 0 }
                            onClick={() => this._handleChange(0)}
                            hover={ false }
                            customStyle={{
                                backgroundColor: this.state.value === 0 ? null : '#FFFFFF',
                                borderColor: !(this.state.value === 0) && "#E6E7E8",
                                borderRadius: "30px",
                                padding: "22px 20px",
                                minWidth: "160px"
                            }}
                        />

                        {
                            !meta.isDependent && this.state.usage.dependents.map((dependent, i) => (
                                <Bubble
                                    key={ dependent.firstname }
                                    label={ dependent.firstname }
                                    isSelected={ this.state.value === i + 1 }
                                    onClick={ () => this._handleChange(i + 1) }
                                    hover={ false }
                                    customStyle={{
                                        backgroundColor: this.state.value === i + 1 ? null : '#FFFFFF',
                                        borderColor: !(this.state.value === i + 1) && "#E6E7E8",
                                        borderRadius: "30px",
                                        padding: "22px 20px",
                                        marginLeft: "10px",
                                        minWidth: "160px"
                                    }}
                                />
                            ))
                        }
                    </div>

                    <UsageTab
                        usage={ this.state.selectedUsage }
                        coverage={ this.props.coverage }
                        meta={ meta }
                        fillColor={ this.state.viewingLastYear ? 'brandGreen' : 'skyBlue' }
                        waivedEHC={ waivedEHC }
                        waivedDental={ waivedDental }
                    />
                </Content>

                <span id="usage" />
            </Container>
        );
    }
}

Usage.propTypes = {
    usage: PropTypes.object,
    coverage: PropTypes.object,
    meta: PropTypes.object,
    whitelabel: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    usage: state.usage.data,
    coverage: state.coverage.data,
    meta: state.user.meta,
    whitelabel: state.whitelabel
});

export default connect(mapStateToProps)(Usage);